
import formAPIDoctorFavVaccine from "./vaccine";


var formattedOutput = null;

const formAPIModelDoctorFavVaccine = (data) => {
  // Apply formAPIModel to each item in the data array
  formattedOutput = data.map(item => formAPIDoctorFavVaccine(item));


  return formattedOutput
};

export default formAPIModelDoctorFavVaccine